// MarketingServices.jsx
import React, { useEffect } from 'react';
import './MarketingServices.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import teamMarketingServicesImage from '../../images/team-marketing-services.jpg'
import Button from '../Button/Button';

const MarketingServices = () => {
 useEffect(() => {
   AOS.init({
     duration: 1000,
     once: true,
     easing: 'ease-out',
   });
 }, []);




 return (
   <div className="MarketingServices">
     <div className="MarketingServices-container">

       <div className="MarketingServices-left" data-aos="fade-up">
         <div className="MarketingServices-image-container">
           <img src={teamMarketingServicesImage} alt="People working on laptops" className="MarketingServices-image" />
         </div>

         <div className="MarketingServices-content">
            <h2 className="MarketingServices-title header-2"> Who we are </h2>
            <p className="MarketingServices-description">
              We are a results-driven digital marketing agency that helps brands grow through strategic content, targeted ads, and real-time engagement. Our team is made up of creatives, strategists, designers, ad specialists, and web experts—all working together to put your brand in front of the right audience, in the right way, at the right time.

              From stunning visuals to high-converting ad campaigns, we offer a full suite of services designed to turn your pages into profitable platforms.

            </p>
           <Button variant="primary" text="Learn More" url="/about" />
         </div>
       </div>
       
       <div className="MarketingServices-right">
         <div className="MarketingServices-card" data-aos="fade-up" data-aos-delay="100">
           <div className="MarketingServices-card-header">
             <h3 className="MarketingServices-card-title">Real People. Real Brands. Real Results.</h3>
           </div>
           <p className="MarketingServices-card-description">
            We've helped startups, personal brands, real estate agencies, logistics companies, fashion houses, restaurants, and corporate brands achieve digital growth. Want proof? Just check our client success stories on our portfolio page.

           </p>
         </div>
         
         <div className="MarketingServices-stats" data-aos="fade-up" data-aos-delay="200">
           <div className="MarketingServices-stat">
             <div className="MarketingServices-stat-number header-3">4M+</div>
             <div className="MarketingServices-stat-label"> Engagement</div>
           </div>
           
           <div className="MarketingServices-stat">
             <div className="MarketingServices-stat-number header-3">283+</div>
             <div className="MarketingServices-stat-label"> Presence</div>
           </div>
           
           <div className="MarketingServices-stat">
             <div className="MarketingServices-stat-number header-3">150+</div>
             <div className="MarketingServices-stat-label"> Impact </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 );
};

export default MarketingServices;